import jazzicon from '@metamask/jazzicon'
import { AvatarComponent } from '@rainbow-me/rainbowkit'
import { ComponentProps, useLayoutEffect, useRef } from 'react'
import { cn } from '@/lib/utils'

type Props = ComponentProps<AvatarComponent> & {
	className?: string
}

export const Avatar = ({ address, size, ensImage, className }: Props) => {
	const ref = useRef<HTMLDivElement>(null)

	useLayoutEffect(() => {
		if (ref.current && address && !ensImage) {
			const el = jazzicon(size, parseInt(address.slice(2, 10), 16))
			el.style.display = 'block'

			ref.current.appendChild(el)
		}

		return () => {
			if (ref.current) {
				ref.current.innerHTML = ''
			}
		}
	}, [address, ensImage])

	if (ensImage) {
		return (
			<img
				src={ensImage}
				alt="Avatar"
				style={{ width: size, height: size }}
				className={cn('rounded-full', className)}
			/>
		)
	}

	return <div ref={ref} className={className} />
}
